{
  "name": "ngfworkspace",
  "version": "1.55.1",
  "license": "MIT",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve advieswijzer --port 8003 --proxy-config projects/advieswijzer/src/proxy.conf.json",
    "build": "ng build advieswijzer",
    "build-prod": "ng build advieswijzer --configuration=production",
    "test": "ng test --watch=true",
    "test-cc": "ng test advieswijzer --browsers=ChromeCI --code-coverage=true --reporters=junit,mocha --watch=false",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@cibg/huisstijl": "^3.19.0",
    "@cibg/ui-components": "20.0.43",
    "core-js": "^3.45.1",
    "file-saver": "^2.0.5",
    "linqts": "^1.15.0",
    "moment": "^2.29.4",
    "reflect-metadata": "^0.1.13",
    "rxjs": "~7.8.2",
    "tinymce": "^7.9.1",
    "tinymce-i18n": "^25.8.4",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.13",
    "@angular/cli": "^20.3.22",
    "@angular/compiler-cli": "^20.3.18",
    "@angular/language-service": "^20.3.18",
    "@types/jasmine": "~5.1.9",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^24.3.1",
    "angular-eslint": "21.0.1",
    "eslint": "^9.39.1",
    "jasmine-core": "~5.10.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-cli": "^2.0.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "karma-mocha-reporter": "~2.2.5",
    "karma-spec-reporter": "~0.0.36",
    "karma-verbose-reporter": "0.0.8",
    "rxjs-tslint": "^0.1.8",
    "ts-node": "~10.9.2",
    "typescript": "~5.8.3",
    "typescript-eslint": "8.46.4"
  }
}